'use strict';
import React from 'react';

/**
 * Defines a site wide footer to contain copyright information and brand tag or slogan.
 * The footer is designed to be sticky, and must follow a primary container element with
 * SiteContent and SiteContent--withFooter classes to handle positioning and offsets.
 *
 * @extends {React.Component}
 * @property {Integer} year Year to use as copyright year.
 */
class SiteFooter extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const year = (new Date()).getFullYear(),
      copyright = '© ' + (this.props.year || year) + ' Conversant, Inc. All rights reserved.';

    return (
      <div className="SiteFooter">
        <div className="SiteFooter-divider"></div>
        <div className="SiteFooter-brandTag">The power of personal.™</div>
        <div className="SiteFooter-copyright">{ copyright }</div>
      </div>
    );
  }
}

SiteFooter.defaultProps = {
};

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteFooter.jsx